import { useCallback, useRef, useState } from 'react';
import { exportDetails, type DetailExportOptions } from '@/lib/excel/export';

export function useDetailExcelExport<T>(rows: T[], options: DetailExportOptions<T>) {
  const exporting = useRef(false);
  const [isExporting, setIsExporting] = useState(false);
  const exportToExcel = useCallback(async () => {
    if (exporting.current) return;
    exporting.current = true;
    setIsExporting(true);
    try {
      await exportDetails(rows, options);
    } finally {
      exporting.current = false;
      setIsExporting(false);
    }
  }, [rows, options]);
  return { exportToExcel, isExporting };
}
